import React from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { COLORS, SIZES } from '../../styles/theme';
import config from '../../config'
import routes from '../../routes'
import banner from '../../images/registration/event-banner.jpg'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${config.assets.entrance.landscape});
  background-repeat: no-repeat;
  background-size: cover;

  ${SIZES.mobile} {
    font-size: 70%;
    background: none;
    background-color: white;
    background-position: center;
  }
  #content {
    color: ${COLORS.primary};
    height: 100vh;
    /* background-image: radial-gradient(circle at left,  rgba(255,255,255,0.9), transparent, transparent); */
 
    #header {
      img {
        display: none;
      }
    }
    ${SIZES.mobile} {
      height: 100%;
      background-color: white;
      #header img {
        display: block;
        margin: 0 auto;
      }
    }
  }
  #action-button {
    width: 50%;
    ${SIZES.mobile} {
      width: 100%; 
    }
    a,
    button {
      background: #002060;
      border: 2px solid ${COLORS.primary};
      width: 45%;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      margin-bottom: 50px;
      font-size: 1.2em;
      color: #AEF3FD;
      font-weight: 500;
      padding: 12px 35px;
      border-radius: 56px;
      font-style: italic ;

      div {
        line-height: 32px;
      }
      div.arrow {
        line-height: 24px;
        font-size: 1.4em;
        align-self: flex-end;
      }
      ${SIZES.mobile} {
        font-size: 1.25em;
        width: 70%;
      }
    }
  }
`

export default function PreRegisterPage() {
  
  return (
    <Page>
      <div id="content">
        <div className="h-100 d-flex justify-content-between flex-wrap">
          <div id="header" className="align-self-end">
            <img src={banner} width="100%" alt="event-banner" />
          </div>
          <div id="action-button" className="align-self-end">
            <Button variant="default" as={Link} to={routes.register}>
              <div>REGISTER HERE</div>
              <div className="arrow">⇀</div>
            </Button>
          </div>
        </div>
      </div>
    </Page>
  )
}